import axios from 'axios';
import { getAuthToken } from '../auth/authSession';

const API_BASE = process.env.REACT_APP_API_URL ?? 'http://localhost:5000/api';

interface ApiResponse<T> {
  success: boolean;
  data?: T;
  shift?: T;
  message?: string;
}

const shiftClient = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json'
  }
});

// attach token
shiftClient.interceptors.request.use(config => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const getErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    return error.response?.data?.message ?? error.message;
  }
  return 'Request failed';
};

// CREATE SHIFT
export const createShift = async (payload: any) => {
  try {
    const { data } = await shiftClient.post<ApiResponse<{ shiftId: number }>>(
      '/shifts',
      payload
    );

    if (!data.success) {
      throw new Error(data.message || 'Failed to create shift');
    }

    return data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

// Get all shifts created by pharmacy

export const getMyShifts = async () => {
  try {
    const { data } = await shiftClient.get('/shifts/my');

    if (!data.success) {
      throw new Error(data.message || 'Failed to fetch shifts');
    }

    return data.shifts;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getShiftById = async (id: string | number) => {
  try {
    const { data } = await shiftClient.get<ApiResponse<any>>(`/shifts/${id}`);

    if (!data.success) {
      throw new Error(data.message || 'Failed to fetch shift');
    }

    return data.shift;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const updateShift = async (id: string | number, payload: any) => {
  try {
    const { data } = await shiftClient.put<ApiResponse<null>>(
      `/shifts/${id}`,
      payload
    );

    if (!data.success) {
      throw new Error(data.message || 'Failed to update shift');
    }

    return data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

// // CLOSE SHIFT (soft delete)
// export const closeShift = async (id: string | number) => {
//   try {
//     const { data } = await shiftClient.delete(`/shifts/${id}`);

//     if (!data.success) {
//       throw new Error(data.message || 'Failed to close shift');
//     }

//     return data;
//   } catch (error) {
//     throw new Error(getErrorMessage(error));
//   }
// };

export const toggleShiftStatus = async (id: string | number) => {
  try {
    const { data } = await shiftClient.patch(`/shifts/${id}/toggle`);

    if (!data.success) {
      throw new Error(data.message || 'Failed to toggle shift');
    }

    return data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getOpenShifts = async (filters?: any) => {
  try {
    const { data } = await shiftClient.get('/shifts', {
      params: filters
    });

    if (!data.success) {
      throw new Error(data.message || 'Failed to fetch shifts');
    }

    return data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};
